import { render, staticRenderFns } from "./ReferralConfirmSlotModal.vue?vue&type=template&id=19844634&scoped=true"
import script from "./ReferralConfirmSlotModal.vue?vue&type=script&lang=js"
export * from "./ReferralConfirmSlotModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralConfirmSlotModal.vue?vue&type=style&index=0&id=19844634&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19844634",
  null
  
)

export default component.exports